import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { MecsDashboardRoutingModule } from './mecs-dashboard-routing.module';
import { MecsHomePageComponent } from './pages/mecs-home-page/mecs-home-page.component';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { MecsDashboardComponent } from './pages/mecs-dashboard/mecs-dashboard.component';
import { MecsDashboardRegionalComponent } from './pages/mecs-dashboard-regional/mecs-dashboard-regional.component';
import { MecsInDepthComponent } from './pages/mecs-in-depth/mecs-in-depth.component';

@NgModule({
  declarations: [
    MecsHomePageComponent,
    MecsDashboardComponent,
    MecsDashboardRegionalComponent,
    MecsInDepthComponent,
  ],
  imports: [
    CommonModule,
    MecsDashboardRoutingModule,
    SharedModule,
    HttpClientModule,
  ],
  providers: [DatePipe]
})
export class MecsDashboardModule {}
